export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const sanitizeMoneyInput = (raw: string, maxDecimals = 2): string => {
  if (!raw) return '';

  let s = raw.replace(',', '.').replace(/[^\d.]/g, '');

  if (s.startsWith('.')) s = '0' + s;

  const firstDot = s.indexOf('.');
  if (firstDot !== -1) {
    s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, '');
  }

  if (maxDecimals >= 0 && firstDot !== -1) {
    const [int, dec] = s.split('.');
    s = dec != null ? `${int}.${dec.slice(0, maxDecimals)}` : int;
  }

  if (s.includes('.')) {
    const [int, dec] = s.split('.');
    const intNorm = int === '' ? '0' : String(Number(int));
    s = `${intNorm}.${dec}`;
  } else {
    if (s !== '') s = String(Number(s));
  }

  if (s === 'NaN') return '';

  return s;
};
